import React from 'react';
import { Card } from '../ui/card';
import { ArrowUpDown } from 'lucide-react';
import { formatDate } from '../../lib/utils';
import { ProposalStatusBadge } from './ProposalStatusBadge';
import { ProposalActionsMenu } from './ProposalActionsMenu';

const SortHeader = ({ field, label, sortField, onToggle }) => (
  <th
    className="text-left p-4 font-medium cursor-pointer hover:bg-muted"
    onClick={() => onToggle(field)}
  >
    <div className="flex items-center gap-2">
      {label} <ArrowUpDown className="h-3 w-3" />
    </div>
  </th>
);

export const ProposalListView = ({ proposals, sortField, onToggleSort, onView, onStatusChange, onConvert, onDelete }) => (
  <Card className="overflow-hidden">
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b bg-muted/50">
            <SortHeader field="title" label="Title" sortField={sortField} onToggle={onToggleSort} />
            <SortHeader field="client_name" label="Client" sortField={sortField} onToggle={onToggleSort} />
            <th className="text-left p-4 font-medium">Company</th>
            <th className="text-left p-4 font-medium">Category</th>
            <SortHeader field="status" label="Status" sortField={sortField} onToggle={onToggleSort} />
            <SortHeader field="amount" label="Amount" sortField={sortField} onToggle={onToggleSort} />
            <SortHeader field="drafted_date" label="Drafted" sortField={sortField} onToggle={onToggleSort} />
            <SortHeader field="sent_date" label="Sent" sortField={sortField} onToggle={onToggleSort} />
            <SortHeader field="signed_date" label="Signed/Rejected" sortField={sortField} onToggle={onToggleSort} />
            <th className="text-right p-4 font-medium">Actions</th>
          </tr>
        </thead>
        <tbody>
          {proposals.map((proposal) => (
            <tr
              key={proposal.proposal_id}
              className="border-b hover:bg-muted/30 cursor-pointer transition-colors"
              onClick={() => onView(proposal)}
              data-testid={`proposal-row-${proposal.proposal_id}`}
            >
              <td className="p-4"><p className="font-medium">{proposal.title}</p></td>
              <td className="p-4 text-muted-foreground">{proposal.client_name}</td>
              <td className="p-4 text-muted-foreground">{proposal.company_name || '-'}</td>
              <td className="p-4 text-sm text-muted-foreground">{proposal.category || '-'}</td>
              <td className="p-4"><ProposalStatusBadge status={proposal.status} /></td>
              <td className="p-4 font-mono">{proposal.amount ? `INR ${proposal.amount.toLocaleString('en-IN')}` : '-'}</td>
              <td className="p-4 text-sm text-muted-foreground">{formatDate(proposal.drafted_date || proposal.created_at)}</td>
              <td className="p-4 text-sm text-muted-foreground">{formatDate(proposal.sent_date)}</td>
              <td className="p-4 text-sm text-muted-foreground">{formatDate(proposal.signed_date || proposal.rejected_date)}</td>
              <td className="p-4 text-right" onClick={(e) => e.stopPropagation()}>
                <ProposalActionsMenu
                  proposal={proposal}
                  onView={onView}
                  onStatusChange={onStatusChange}
                  onConvert={onConvert}
                  onDelete={onDelete}
                  testIdPrefix="actions"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </Card>
);
